<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card class="mb-5">
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="2" class="mr-5 mb-1">
              Cabin List
            </v-col>
            <v-col cols="12" md="2" class="mr-5 mb-1 ">
              <template>
                <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    dense
                    outlined
                ></v-text-field>
              </template>
            </v-col>
            <v-col cols="auto">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      depressed
                      color="warning"
                      v-on="on"
                      v-on:click="addCabin"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add Item</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="dessertsItemsWithSno"
          class="elevation-1"
          :search="search"
          :loading="loading"
      >
          <template v-slot:item.gender="{ item }">
            <div v-if="item.gender === 'Male'"><v-btn color="primary" small>Male</v-btn></div>
            <div v-else-if="item.gender === 'Female'"><v-btn color="pink" small>Female</v-btn></div>
            <div v-else><v-btn small>Both</v-btn></div>
          </template>
        <template v-slot:item.status="{ item }">
            <div v-if="parseInt(item.status) === 1"><v-btn color="green" small>Active</v-btn></div>
            <div v-else><v-btn color="red" small>Inactive</v-btn></div>
          </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="editCabinData(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-pencil</v-icon>
              </v-chip>
            </template>
            <span>Cabin Edit</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> Cabin: {{ cabinModalTitle }}</v-card-title>
            <v-card-text>
              <v-text-field
                  v-model="submitData.name"
                  label="Name"
              ></v-text-field>
              <v-text-field
                  v-model="submitData.floor"
                  label="Floor number"
                  type="number"
              ></v-text-field>
              <v-select
                  v-model="submitData.gender"
                  :items="genders"
                  label="Gender"
              ></v-select>
              <v-text-field
                  v-model="submitData.cabin_charge"
                  label="Cabin Charge"
              ></v-text-field>
              <v-select
                  v-model="submitData.status"
                  :items="status"
                  label="Status"
                  item-value="key"
                  item-text="value"
              ></v-select>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" dark @click="resetSubmitForm"> Cancel</v-btn>
              <v-btn color="primary" @click="dataSubmit"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>

</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      search: "",
      loading: true,
      loadingStatus: true,
      dialog: false,
      cabinModalTitle: null,
      headers: [
        {text: "SL", value: "sno",},
        {text: "Name", value: "name"},
        {text: "Floor", value: "floor"},
        {text: "Cabin Charge", value: "cabin_charge"},
        {text: "Gender", value: "gender"},
        {text: "Status", value: "status"},
        {text: "Action", value: "actions"},
      ],
      desserts: [],
      items: [
        {text: "Dashboard", disabled: false, href: "/",},
        {text: "Cabin List", disabled: false, href: "/",},
      ],

      submitData: {
        id: null,
        name: null,
        floor: null,
        gender: null,
        cabin_charge: null,
        user_id: null,
        status: null,
      },
      genders:[
        'Male',
        'Female',
        'Both',
      ],
      status: [
        {key: 1, value: "Active"},
        {key: 0, value: "Inactive"},
      ],
    };
  },
  created() {
    this.cabinList();
    this.permissionCheck();
  },
  computed: {
    dessertsItemsWithSno() {
      return this.desserts.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {
    permissionCheck() {
      atshq
          .get("users/user-group?id=" + localStorage.getItem("userId"))
          .then((response) => {
            if (!(response.data.data.includes("ot-setup") || response.data.data.includes("admin"))) {
              this.$router.go(-1);
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    cabinList() {
      atshq
          .get("cabin/list")
          .then((response) => {
            this.desserts = response.data.cabins;
            this.loading = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },

    resetSubmitForm() {
      this.dialog = false;
      this.cabinModalTitle = '';
      this.submitData.id = null;
      this.submitData.name = null;
      this.submitData.floor = null;
      this.submitData.gender = null;
      this.submitData.cabin_charge = null;
      this.submitData.status = null;
    },
    addCabin() {
      this.dialog = true;
      this.cabinModalTitle = "Add";
    },
    editCabinData(item) {
      this.dialog = true;
      this.cabinModalTitle = 'Edit';
      this.submitData.id = item.id;
      this.submitData.name = item.name;
      this.submitData.floor = item.floor;
      this.submitData.gender = item.gender;
      this.submitData.cabin_charge = item.cabin_charge;
      this.submitData.status = parseInt(item.status);
    },



    dataSubmit() {
      let submitUrl = this.submitData.id ? "cabin/cabin-update/" + this.submitData.id : "cabin/cabin-store";
      if (this.submitData.id) {
        atshq
            .post(submitUrl, {
              submitData: this.submitData,
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              this.loadingStatus = false;
              this.$noty.success(response.data.message);
              this.dialog = false;
              this.cabinList();
              this.resetSubmitForm();
            })
            .catch((e) => {
              this.$noty.error(e.response.data.message);
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      } else {
        atshq
            .post(submitUrl, {
              submitData: this.submitData,
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              this.loadingStatus = false;
              this.$noty.success(response.data.message);
              this.dialog = false;
              this.cabinList();
              this.resetSubmitForm();
            })
            .catch((e) => {
              this.$noty.error(e.response.data.message);
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      }
    },
  },
};
</script>
